'use client';

import { createContext, useContext, useEffect, useState } from 'react';
import { reaAnalytics } from '@referralexchange/rea-analytics';
import type { GeoData } from '@referralexchange/rea-analytics';

type AnalyticsContextType = {
  geo: GeoData | null;
  reaa: (...args: any[]) => void;
};

const AnalyticsContext = createContext<AnalyticsContextType>({
  geo: null,
  reaa: () => {},
});

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const [geo, setGeo] = useState<GeoData | null>(null);


  const reaa = (...args: any[]) => {
    window.rea_dataLayer = window.rea_dataLayer || [];
    window.rea_dataLayer.push(args);
  };

  useEffect(() => {
    // setup data layer
    window.rea_dataLayer = window.rea_dataLayer || [];
    window.reaa = function () {
      window.rea_dataLayer.push(arguments);
    };

    const apiEndpoint = process.env.BACKEND_ORIGIN ?? 'https://www.realestateagents.com';
    const debug = !apiEndpoint.includes('www.realestateagents.com');

    reaAnalytics
      .init({
        apiEndpoint,
        debug,
        autoEvents: ['first_visit', 'session_start', 'user_engagement', 'scroll', 'outbound_click'],
      })
      .then(async () => {
        const geo = await reaAnalytics.geo();
        if (geo?.country) {
          setGeo(geo);
        }
      })
      .catch((err) => {
        console.error('reaAnalytics init failed:', err);
      });
  }, []);

  return (
    <AnalyticsContext.Provider value={{ geo, reaa }}>
      {children}
    </AnalyticsContext.Provider>
  );
}

export function useAnalytics(): AnalyticsContextType {
  return useContext(AnalyticsContext);
}
